//const env = process.env.NODE_ENV || "local";
const env ="uat";
const config = {
  local: {
    BASE_URL: "http://localhost:8080",
  },
  uat: {
    BASE_URL: "https://panaccoapi-uat-1082177167010.asia-south1.run.app",
  },
  production: {
    BASE_URL: "https://panaccoapi-453601304730.asia-south1.run.app",
  },
};
module.exports = config[env];

